export default {
  color:"blue"
};
